import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NumberInput, Checkbox } from '@vtblife/uikit';

import classname from '@search/classname/src';
// import { BuildEpoch } from '@search/filter-enums/enums';
import { NumberInputRange } from '../../common/NewNumberInputRange/NumberInputRange';
import { NumberFormats } from '../../common/NewRangeInput/RangeInput';
import { YearBuildingFilter, BuildEpochFilter } from '../../../models/Filter';
import { INumberRange } from '../../../types/IRange';
import { MobileFilter2 } from '../../filter/MobileFilter2';
import { BuildEpochFilterView } from '../build_epoch/BuildEpochFilterView';

import './YearBuildingFilter.css';

const cn = classname.bind(null, 'YearBuildingFilter');

interface IYearBuildingFilterProps {
    filter: YearBuildingFilter;
    handleChange: (value: YearBuildingFilter | BuildEpochFilter) => void;
    isMobile?: boolean;
    withoutEpochTitle?: boolean;
    withoutTitle?: boolean;
    isNewBuilding?: boolean;
    filter2: BuildEpochFilter;
    classNameGroup?: string;
}

const getFromSessionStorage = (): INumberRange | null => {
    const v = sessionStorage.getItem('yearBuilding');

    if (v) return JSON.parse(v);

    return null;
};

export const YearBuildingFilterView: React.FC<IYearBuildingFilterProps> = ({
    filter,
    handleChange,
    withoutTitle = false,
    isMobile,
    filter2,
    isNewBuilding = false,
    withoutEpochTitle = false,
    classNameGroup
}) => {
    const [ isDisable, setIsDisable ] = useState(false);
    const yearValue = useRef(filter.value);

    const onChange = useCallback((value: INumberRange) => {
        yearValue.current = value;
        handleChange(new YearBuildingFilter(value));
    }, [ handleChange ]);

    const getLabels = useCallback((label: 'from' | 'to'): string => {
        const f = getFromSessionStorage();

        switch (label) {
            case 'from':
                return `${f?.from ?? 'с'}`;
            case 'to':
                return `${f?.to ?? 'по'}`;
            default:
                return '';
        }
    }, []);

    // const onChangeEpoch = useCallback((value: boolean, type: BuildEpoch) => {
    //     const epochs = new Set(filter2?.buildEpoch);
    //
    //     epochs[value ? 'add' : 'delete'](type);
    //
    //     const res = Array.from(epochs);
    //
    //     if (res.length) {
    //         ! getFromSessionStorage() && sessionStorage.setItem('yearBuilding', JSON.stringify(yearValue.current));
    //         handleChange(new YearBuildingFilter({ from: null, to: null }));
    //
    //         handleChange(new BuildEpochFilter(res));
    //     }
    //
    //     if (! res.length) {
    //         const f = getFromSessionStorage();
    //
    //         if (f?.from || f?.to) {
    //             onChange(f);
    //             sessionStorage.removeItem('yearBuilding');
    //         }
    //
    //         handleChange(new BuildEpochFilter([ ]));
    //     }
    // }, [ handleChange, filter2 ]);

    useEffect(() => {
        setIsDisable(filter2?.buildEpoch?.length as number > 0);
    }, [ filter2 ]);

    const currentYear = new Date().getFullYear();

    const onChangeNewBuilding = React.useCallback((value: number) => {
        yearValue.current.to = isNaN(value) ? null : value;

        handleChange(new YearBuildingFilter({
            from: null,
            to: yearValue.current.to
        }));
    }, [ handleChange ]);

    const onChangeCheckbox = React.useCallback((value: boolean) => {
        if (! value) return;

        onChangeNewBuilding(currentYear - 1);
    }, [ onChangeNewBuilding ]);

    const newBuildingFields = (
        <MobileFilter2 desktopTitleGap={! isMobile} filterTitle={isMobile ? 'Срок сдачи' : null}>
            <div className={cn('newBuilding', { isMobile })}>
                <NumberInput
                    onChange={onChangeNewBuilding}
                    placeholder='до'
                    separator={false}
                    max={3000}
                    value={yearValue.current.to ?? undefined}
                />
                <div style={{ width: 'max-content' }}
                >
                    <Checkbox
                        name='Done'
                        // @ts-ignore
                        value={yearValue.current.to && yearValue.current.to <= currentYear - 1}
                        onChange={onChangeCheckbox}
                        variant='filter'
                        block
                    >
                        Сдан
                    </Checkbox>
                </div>
            </div>
        </MobileFilter2>
    );

    return isNewBuilding ? newBuildingFields : (
        <>
            <MobileFilter2 desktopTitleGap={! isMobile} filterTitle={withoutTitle ? undefined : 'Год постройки'}>
                <NumberInputRange
                    max={3000}
                    format={NumberFormats.OrdinalNumber}
                    size='s'
                    fromLabel={getLabels('from')}
                    toLabel={getLabels('to')}
                    value={filter.value}
                    onChange={onChange}
                    nameFrom='buildingYearFrom'
                    nameTo='buildingYearTo'
                    disabled={isDisable}
                />
                {filter2 && <BuildEpochFilterView
                    filter={filter}
                    isMobile={isMobile}
                    onChange={onChange}
                    // onChangeEpoch={onChangeEpoch}
                    withoutEpochTitle={withoutEpochTitle}
                />}
            </MobileFilter2>
        </>

    );
};
